export const headersDestaques = [
  { text: 'ID', width: 2, key: 'destaqueId' },
  { text: 'Criticidade', width: 7, key: 'destaqueCriticidade' },
  { text: 'Data', width: 7, key: 'destaqueData' },
  { text: 'Título', width: 25, key: 'destaqueTitulo' },
  { text: 'Descrição', width: 45, key: 'destaquesDescricao' },
];

export const valoresExibidosDestaques: Record<string, string> = {
  id: 'ID',
  dataRegistro: 'Data de Registro',
  dataAtualizacao: 'Última Atualização',
  dataUltimaVisualizacao: 'Última Visualização',
  dataUltimaAtualizacao: 'Última Atualização',
  nEdicoes: 'Edições',
  nVisualizacoes: 'Visualizações',
  nVisualizadores: 'Visualizadores',
  usuarioRegistro: 'Responsável pelo Registro',
  usuarioAtualizacao: 'Responsável Ult. Atualização',
  usuarioUltimaVisualizacao: 'Responsável Ult. Visualização',
  observacoes: 'Observações',

  // Fase
  nivelCriticidade: 'Criticidade',
  dataDestaque: 'Data',
  titulo: 'Título',
  descricao: 'Descrição',
  link: 'Link',

  //Separadores
  separador: '',
  separadorLog: '',
  separadorDestaque: '',
};

export const fieldObjectProaq = [
  'usuarioRegistro.nomeCompleto',
  'usuarioAtualizacao.nomeCompleto',
  'usuarioUltimaVisualizacao.nomeCompleto',
  'responsavel.nomeCompleto',
  'proaq.id',
  'proaqResponsavel.responsavel',
  'produtoDAF.produtoFarmaceutico',
  'denominacaoGenerica.denominacaoGenerica',
  'KitProdutoDAF.nomeKit',
];
